import _sfc_main from './PortfolioAction.vue2.js';
import normalizeComponent from '../../../_virtual/_plugin-vue2_normalizer.js';

var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "fds-portfolio-action" }, [_vm._t("action", function() {
    return [_vm._t("action:button", function() {
      return [_c("button", { staticClass: "fds-ui-button fds-ui-button--icon fds-portfolio-action__button", attrs: { "type": "button", "disabled": !_vm.active, "aria-haspopup": "dialog" }, on: { "click": function($event) {
        $event.stopPropagation();
        return _setup.openModal();
      } } }, [_vm._t("action:button:content", null, null, { $slots: _vm.$slots, $scopedSlots: _vm.$scopedSlots, isModalVisible: _setup.isModalVisible, openModal: _setup.openModal, closeModal: _setup.closeModal })], 2)];
    }, null, { $slots: _vm.$slots, $scopedSlots: _vm.$scopedSlots, isModalVisible: _setup.isModalVisible, openModal: _setup.openModal, closeModal: _setup.closeModal }), _vm._t("action:modal", function() {
      return [_c(_setup.HoistComponent, [_c(_setup.UiModal, { staticClass: "fds-portfolio-action__modal", scopedSlots: _vm._u([{ key: "root", fn: function() {
        return [_vm._t("action:modal:content", null, null, { $slots: _vm.$slots, $scopedSlots: _vm.$scopedSlots, isModalVisible: _setup.isModalVisible, openModal: _setup.openModal, closeModal: _setup.closeModal })];
      }, proxy: true }], null, true), model: { value: _setup.isModalVisible, callback: function($$v) {
        _setup.isModalVisible = $$v;
      }, expression: "isModalVisible" } })], 1)];
    }, null, { $slots: _vm.$slots, $scopedSlots: _vm.$scopedSlots, isModalVisible: _setup.isModalVisible, openModal: _setup.openModal, closeModal: _setup.closeModal })];
  }, null, { $slots: _vm.$slots, $scopedSlots: _vm.$scopedSlots, isModalVisible: _setup.isModalVisible, openModal: _setup.openModal, closeModal: _setup.closeModal })], 2);
};
var _sfc_staticRenderFns = [];
_sfc_render._withStripped = true;
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
__component__.options.__file = "/home/ubuntu/actions-runner/_work/library/library/packages/library/src/components/portfolio/components/PortfolioAction.vue";
var PortfolioAction = __component__.exports;

export { PortfolioAction as default };
